export default __webpack_public_path__ + "static/media/nccu.18c1ce7a.png";